import { render, staticRenderFns } from "./payment-status.vue?vue&type=template&id=73b8f066&scoped=true"
import script from "./payment-status.vue?vue&type=script&lang=js"
export * from "./payment-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b8f066",
  null
  
)

export default component.exports